controllers.controller('FavoritesController', [
    '$scope', '$state', '$ionicLoading',
    'config', 'constants', 'AssetService', 'FavoritesService','LocaleService',
    function ($scope, $state, $ionicLoading,
              config, Const, AssetService, FavoritesService, LocaleService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.assets = [];
        $scope.categories = filterCategories(AssetService.assetCategories || Const.assetsTypes);

        $scope.selectedIndex = $scope.categories[0].id;

        $scope.favorites = FavoritesService.getAll();

        $scope.search = {};

        filterAssets($scope.selectedIndex);

        $scope.toggleCategory = function (category) {
            $scope.selectedIndex = category;
            filterAssets(category);
        };

        $scope.toggle = function (assetId) {
            var asset = AssetService.collection.get({id: assetId});
            if (asset.isFavorite) {
                FavoritesService.remove(assetId);
                asset.isFavorite = false;
            } else {
                FavoritesService.add(assetId);
                asset.isFavorite = true;
            }
        };

        function filterCategories(categories) {
            if (!AssetService.collection) return;

            var uniqCategories = _.uniq(AssetService.clientCollection.getAll()
                .map(function (asset) {
                    return asset.category
                }));

            var filteredCategories = categories.filter(function (category) {
                return uniqCategories.indexOf(category.id) > -1
            });

            //set selected to false
            filteredCategories = filteredCategories.map(function (category) {
                return _.assign(category, {selected: false})
            });
            //set selected to first category which is not favorites
            filteredCategories[0].selected = true;
            return filteredCategories;
        }

        function filterAssets(category) {
            if (!AssetService.collection) return;

            var filter = {
                category: category || $scope.categories[0]
            };

            $scope.assets = AssetService.clientCollection.find(filter);
        }

        function clear() {
            $scope.assets = [];
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }]);
